module.exports = __webpack_public_path__ + "static/ballettowel-98ba120c19d8ee80185daba846aa1517.jpeg";